import React, { useEffect } from 'react';
import history from 'src/history';
import { IRequest } from 'src/models/request.model';
import FlightRequestReviewView from './flight-request.review.view';

type IProps = {
  data?: IRequest;
};

const FlightRequestReview: React.FC<IProps> = ({ data }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (!data) {
    history.push('/flight/request');

    return null;
  }

  return <FlightRequestReviewView data={data} />;
};

export default FlightRequestReview;
